import type { FC } from "react";
import React, { memo } from "react";
import { isSingle } from "../../compareUtils";
import FeaturesSingle from "./FeaturesSingle";
import FeaturesMultiple from "./FeaturesMultiple";
import { useGetCompareGrades } from "../../compareHooks";
import SectionCollapse from "../SectionCollapse";
import { CollapseSection, trackExpandedItem } from "../../../../../../utils/tracking";
import { useCompareContext } from "../../CompareContext";
import { useCarConfigLabel } from "../../../../../../utils/labelUtils";

const Features: FC = () => {
    const { openedCollapses, setOpenedCollapses } = useCompareContext();
    const grades = useGetCompareGrades();
    const isSingleGrade = isSingle(grades);

    const carConfigLbxCompareIncludedFeatures = useCarConfigLabel("carConfigLbxCompareIncludedFeatures");

    return (
        <SectionCollapse
            open={openedCollapses.includes(CollapseSection.SectionFeatures)}
            onChange={() => {
                const isOpen = openedCollapses.includes(CollapseSection.SectionFeatures);

                trackExpandedItem(isOpen, CollapseSection.SectionFeatures);

                setOpenedCollapses(
                    isOpen
                        ? openedCollapses.filter((item) => item !== CollapseSection.SectionFeatures)
                        : [...openedCollapses, CollapseSection.SectionFeatures],
                );
            }}
            summary={carConfigLbxCompareIncludedFeatures}
        >
            {isSingleGrade ? <FeaturesSingle /> : <FeaturesMultiple />}
        </SectionCollapse>
    );
};

export default memo(Features);
